import { createRouter, createWebHistory } from 'vue-router';
import Layout from "../components/layout/Layout.vue";

const routes = [
    
    // home
    {
        path: '/',
        redirect: '/home',
        meta: {
            title: "홈",
        },
    }, 

    // 홈
    {
        path: '/home',
        component: () => import('../views/home/home'),
        meta: {
            title: "Home",
            layout: Layout,
        },

    },

    // 회사소개
    {
        path: '/company',
        component: () => import('../views/company/company'),
        meta: {
            title: "회사소개",
            layout: Layout,
        },
    },

    // 사업분야
    {
        path: '/business',
        component: () => import('../views/business/business'),
        meta: {
            title: "사업분야",
            layout: Layout,
        },
    },

    // 서비스 > 웹(모바일웹)
    {
        path: '/webmob',
        component: () => import('../views/service/webmob'),
        meta: {
            title: "서비스 > 웹(모바일웹)",
            layout: Layout,
        },
    },

    // 서비스 > 모바일 앱
    {
        path: '/mobileapp',
        component: () => import('../views/service/mobileapp'),
        meta: {
            title: "서비스 > 모바일 앱",
            layout: Layout,
        },
    },

    // 서비스 > IOT 서비스
    {
        path: '/iot',
        component: () => import('../views/service/iot'),
        meta: {
            title: "서비스 > IOT 서비스",
            layout: Layout,
        },
    },

    // 서비스 > 동영상 미디어 서비스
    {
        path: '/video',
        component: () => import('../views/service/video'),
        meta: {
            title: "서비스 > 동영상 미디어 서비스",
            layout: Layout,
        },
    },

    // 서비스 > POS/Kiosk
    {
        path: '/poskiosk',
        component: () => import('../views/service/poskiosk'),
        meta: {
            title: "서비스 > POS/Kiosk",
            layout: Layout,
        },
    },

    // 서비스 > 맞춤형 소프트웨어
    {
        path: '/customSoftware',
        component: () => import('../views/service/customSoftware'),
        meta: {
            title: "서비스 > 맞춤형 소프트웨어",
            layout: Layout,
        },
    },

    // 솔루션 > 온마이스
    {
        path: '/onmice',
        component: () => import('../views/solution/onmice'),
        meta: {
            title: "솔루션 > 온마이스",
            layout: Layout,
        },
    },

    // 솔루션 > 클래스나옴
    {
        path: '/classnaom',
        component: () => import('../views/solution/classnaom'),
        meta: {
            title: "솔루션 > 클래스나옴",
            layout: Layout,
        },
    },

    // 포트폴리오
    {
        path: '/portfolio',
        component: () => import('../views/portfolio/list'),
        meta: {
            title: "포트폴리오",
            layout: Layout,
        },
    },

    // 포트폴리오 상세 new
    {
        path: '/portfolio/view/:id',
        component: () => import('../views/portfolio/view'),
        meta: {
            title: "포트폴리오 상세",
            layout: Layout,
        },
    },

    // 포트폴리오 상세
    {
        path: '/portfolio/detail1',
        component: () => import('../views/portfolio/detail1'),
        meta: {
            title: "포트폴리오 상세",
            layout: Layout,
        },
    },


    // 상담신청
    {
        path: '/consult',
        component: () => import('../views/consult/consult'),
        meta: {
            title: "상담신청",
            layout: Layout,
        },
    },
   


    
];

const router = createRouter({
    // mode: 'history',
    history: createWebHistory(),
    linkActiveClass: "active",
    //linkExactActiveClass: 'active',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { left: 0, top: 0 };
        }
    },
});


router.beforeEach((to, from, next) => {

    /*
     * to: 이동할 url 정보가 담긴 라우터 객체
     * from: 현재 url 정보가 담긴 라우터 객체
     * next: to에서 지정한 url로 이동하기 위해 꼭 호출해야 하는 함수
     * next() 가 호출되기 전까지 화면 전환되지 않음
    */

		next();

});

export default router;